// ============================================================
// 作品区交互：RUN 渲染模拟 + 画廊 + 灯箱
// ============================================================

const RUN_PROFILES = {
  video: {
    total: 3000,
    log: (frame) => `rendering frame ${String(frame).padStart(4, "0")}/3000`,
  },
  image: {
    phases: ["sampling latent space …", "refining details …", "upscaling to 8K …"],
    log: null,
  },
  music: {
    phases: ["composing bar 32 @ 128bpm …", "mixing track 3/8 …", "mastering waveform …"],
    log: null,
  },
};

export default function initWorks() {
  // ---------- RUN 按钮 ----------
  document.querySelectorAll("[data-run]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const key = btn.dataset.run;
      const box = document.querySelector(`[data-runbox="${key}"]`);
      if (!box || btn.classList.contains("is-running")) return;

      const profile = RUN_PROFILES[key];
      const bar = box.querySelector(".run-progress__bar");
      const logEl = box.querySelector(".run-log");
      const outEl = box.querySelector(".run-out");
      const gallery = box.querySelector(".run-gallery");
      const wave = box.querySelector(".run-wave");
      const hidden = [outEl, gallery, wave].filter(Boolean);

      hidden.forEach((el) => el.setAttribute("hidden", ""));
      box.hidden = false;
      btn.classList.add("is-running");
      btn.querySelector(".btn-jk__ic").textContent = "…";

      const dur = key === "video" ? 1800 : 2200;
      const start = performance.now();

      const complete = () => {
        bar.style.width = "100%";
        if (profile.log) logEl.textContent = profile.log(profile.total);
        else if (profile.phases) logEl.textContent = profile.phases[profile.phases.length - 1];
        btn.classList.remove("is-running");
        btn.querySelector(".btn-jk__ic").textContent = "✓";
        if (outEl) outEl.hidden = false;
        if (gallery) gallery.hidden = false;
        if (wave) wave.hidden = false;
      };

      const step = (now) => {
        const p = Math.min((now - start) / dur, 1);
        bar.style.width = `${Math.round(p * 100)}%`;

        if (profile.log) {
          const frame = Math.min(profile.total, Math.round(p * profile.total));
          logEl.textContent = profile.log(frame);
        } else if (profile.phases) {
          const idx = Math.min(profile.phases.length - 1, Math.floor(p * profile.phases.length));
          logEl.textContent = profile.phases[idx];
        }

        if (p < 1) {
          requestAnimationFrame(step);
        } else {
          complete();
        }
      };
      requestAnimationFrame(step);

      // 兜底：rAF 受限环境下也保证完成（与开机动画同策略）
      setTimeout(complete, dur + 400);
    });
  });

  // ---------- 灯箱 ----------
  const lightbox = document.getElementById("lightbox");
  if (!lightbox) return;
  const img = document.getElementById("lightbox-img");
  const caption = document.getElementById("lightbox-caption");

  const open = (src, cap) => {
    img.src = src;
    img.alt = cap || "作品";
    caption.textContent = cap || "";
    lightbox.classList.add("is-open");
    lightbox.setAttribute("aria-hidden", "false");
  };
  const close = () => {
    lightbox.classList.remove("is-open");
    lightbox.setAttribute("aria-hidden", "true");
  };

  document.querySelectorAll("[data-lightbox]").forEach((item) => {
    item.addEventListener("click", () => {
      // 优先取按钮内 <img> 的 src（Parcel 构建后已重写为哈希路径）
      const imgEl = item.querySelector("img");
      const src = imgEl ? imgEl.src : item.dataset.lightbox;
      open(src, item.dataset.caption || "");
    });
  });

  lightbox.addEventListener("click", close);
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") close();
  });
}
